import { Component, Injector, OnInit } from '@angular/core';

import { environment } from 'src/environments/environment';
import { BaseComponent } from '../common/BaseComponent';
import { BnNgIdleService } from 'bn-ng-idle';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html'
})
export class LogoutComponent extends BaseComponent implements OnInit {

  constructor(injector: Injector, private bnIdle: BnNgIdleService) { super(injector);}

  ngOnInit(): void {
    //sessionStorage.clear();
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("loginEmail");
    sessionStorage.removeItem("searchUserRole");
    sessionStorage.removeItem("resource_url");

    //remove backUrl session, backUrlExists
    sessionStorage.removeItem("backUrl");    
  
    console.log("idle service stop timer");
    this.bnIdle.stopTimer();

    this.route.queryParams.subscribe(params => {
      var sto = (params['p_session_timeout'])?.trim() ?? '';
      if (sto === 'true') {
        const redirectUrl = environment.getOamLogoutUri() + "?end_url=" + environment.getSessionTimeoutUri();
        window.location.href = redirectUrl;
      } else {
        const redirectUrl = environment.getOamLogoutUri() + "?end_url=" + environment.getLogoutSuccessUri();
        window.location.href = redirectUrl;
      }
    });

  }

  ngOnDestroy(): void {
    //restart the watching
    this.bnIdle.startWatching(900).subscribe((res) => {
      if (res) {
        console.log('session expired');
        window.location.href = "/opsbpssecure/public/sessionTimeout";
      }
    });
  }
}
